import PlayListService from 'services/PlayListService'

const getPdfFilename = (name) => {
  const sanitized = String(name || 'Playlist')
    .replace(/[\\/:*?"<>|\p{Cc}]/gu, '_')
    .trim()
    .replace(/[. ]+$/u, '')

  return `${sanitized || 'Playlist'}.pdf`
}

const downloadPlaylistPdf = async (playlist) => {
  const id = playlist?.playlistid
  if (id === undefined || id === null || String(id).trim() === '') {
    throw new Error('Playlist ID is required')
  }

  const response = await PlayListService.downloadPdf(id)
  const blob = response?.data
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error('Empty or invalid playlist PDF response')
  }

  const type = blob.type.toLowerCase()
  const prefix = await blob.slice(0, 1024).text()
  if (type.includes('html') || type.includes('json') || !prefix.includes('%PDF-')) {
    throw new Error('Invalid playlist PDF response')
  }

  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')

  try {
    link.href = objectUrl
    link.download = getPdfFilename(playlist.name)
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
  } finally {
    link.remove()
    // Give the browser time to consume the URL before releasing its data.
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
  }

  return true
}

export default downloadPlaylistPdf
